export default __webpack_public_path__ + "static/media/tool_instagram.3d6ab0d4.png";